import React, { useState } from 'react';
import './AdminCreateCampaignPage.styles.scss';
import { Button, Collapse, Form, Input, Select, Radio, DatePicker, message, InputNumber } from 'antd';
import { AiFillInstagram, AiOutlineTwitter, AiOutlineFire, AiFillYoutube, AiOutlinePaperClip } from 'react-icons/ai';
import { RiUserSettingsLine } from 'react-icons/ri';
import { BiSearch } from 'react-icons/bi';
import uuid from 'react-uuid';
import _ from 'lodash';
import moment from 'moment';
import { GiHumanTarget } from 'react-icons/gi';
import { MdSchedule } from 'react-icons/md';

import BaseLayoutComponent from '../../components/Layout/Admin/BaseLayoutComponent';
import TopSubHeaderComponent from '../../components/Admin/Common/TopSubHeaderComponent';
import { useGlobalState } from '../../store/state';
import { CreateCampaign } from '../../apis/Admin/Campaigns/CreateCampaign';
import { useHistory } from 'react-router-dom';

const { Panel } = Collapse;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Item } = Form;

const AdminCreateCampaignPage = () => {
  const [user] = useGlobalState('user');
  const history = useHistory();
  const [campaignData, updateCampaignData] = useState({
    title: '',
    objective: '',
    platform: '',
    budget: 0,
    brand: '',
    company: '',
    influencersType: '',
    gender: '',
    age: '',
    languages: '',
    interest: '',
    location: '',
    influencerList: '',
    influencerscount: 0,
    startdate: '',
    enddate: '',
    description: '',
    hashtags: '',
    keywords: '',
    mentions: '',
    referenceLinks: '',
    campaignGuidelines: '',
  });
  const campaignobjective = [
    {
      key: 'Reach',
      name: 'Reach',
    },
    {
      key: 'Engagement',
      name: 'Engagement',
    },
    {
      key: 'Video Views',
      name: 'Video Views',
    },
  ];
  const platform = [
    {
      key: 'instagram',
      name: 'Instagram',
    },
    {
      key: 'twitter',
      name: 'Twitter',
    },
    {
      key: 'youtube',
      name: 'Youtube',
    },
  ];

  const influencersType = [
    {
      key: 'Nano',
      name: 'Nano',
    },
    {
      key: 'Micro',
      name: 'Micro',
    },
    {
      key: 'Macro',
      name: 'Macro',
    },
    {
      key: 'Mega',
      name: 'Mega',
    },
    {
      key: 'Celebrities',
      name: 'Celebrities',
    },
  ];
  const gender = [
    {
      key: 'male',
      name: 'Male',
    },
    {
      key: 'female',
      name: 'Female',
    },
    {
      key: 'other',
      name: 'Other',
    },
  ];
  const ageGroup = [
    {
      key: '18-25',
      name: '18-25 Years',
    },
    {
      key: '25-35',
      name: '25-35 Years',
    },
    {
      key: '35-45',
      name: '35-45 Years',
    },
    {
      key: '45+',
      name: '45+ Years',
    },
  ];
  const [form] = Form.useForm();
  const [requiredMark, setRequiredMarkType] = useState('optional');

  const onRequiredTypeChange = ({ requiredMarkValue }) => {
    setRequiredMarkType(requiredMarkValue);
  };

  const syncCampaignData = ({ value, key }) => {
    if (key === 'date') {
      updateCampaignData({ ...campaignData, startdate: moment.utc(value[0]).valueOf(), enddate: moment.utc(value[1]).valueOf() });
    } else {
      updateCampaignData({ ...campaignData, [key]: value });
    }
  };

  const submitCampaign = async () => {
    try {
      const campaign = {
        name: campaignData?.title,
        objective: campaignData?.objective,
        platform: campaignData?.platform,
        budget: campaignData?.budget,
        influencerscount: 1000,
        brief: campaignData?.description,
        thingstoavoid: campaignData?.campaignGuidelines,
        hashtags: [...campaignData?.hashtags?.split(',')],
        keywords: [...campaignData?.keywords?.split(',')],
        brand: campaignData?.brand,
        company: campaignData?.company,
        mentions: [...campaignData?.mentions?.split(',')],
        startdate: campaignData?.startdate,
        enddate: campaignData?.enddate,
        influencerscount: campaignData?.influencerscount,
        influencersettings: {
          influencersource: [...campaignData?.influencersType],
          location: [...campaignData?.location?.split(',')],
          // topics: [...campaignData?.topics?.split(',')],
          language: [...campaignData?.languages?.split(',')],
          gender: campaignData.gender,
          age: campaignData?.ageGroup,
        },
        referencelink: [...campaignData?.referenceLinks?.split(',')],
        deliverables: [
          {
            creatives: 1,
            format: '',
            assets: [],
          },
        ],
      };
      const res = await CreateCampaign({ token: user.accessToken, data: campaign });
      if (res?.status === 200) {
        message.success('Campaign created successfully');
        if (res?.response?.id) {
          history.push(`/admin/dashboard/campaigns/${res.response.id}?status=review&view=brief`);
        } else {
          history.push(`/admin/dashboard/campaigns`);
        }
      } else {
        message.error('There is some while creating campaign!! Please try again');
        history.push(`/admin/dashboard/campaigns`);
      }
    } catch (err) {
      message.error(err.message);
      history.push(`/admin/dashboard/campaigns`);
      console.log(err);
    }
  };

  return (
    <BaseLayoutComponent>
      <TopSubHeaderComponent className="py-2 sticky">
        <div className="d-flex flex-wrap align-items-center">
          <div className="col-md-6">
            <p className="m-0"><strong>Create Campaign</strong></p>
          </div>
        </div>
      </TopSubHeaderComponent>
      <div>
        <div className="py-3">
          <Form
            form={form}
            layout="vertical"
            initialValues={{ requiredMarkValue: requiredMark }}
            onValuesChange={onRequiredTypeChange}
            requiredMark={requiredMark}
          >
            <div className="col-md-8 pr-2">
              <Collapse
                className="acc_campaign mb-2 common_collapse"
                showArrow={false}
                defaultActiveKey={['base-1']}
              >
                <Panel showArrow={false}
                  key="base-1"
                  header={<h3><RiUserSettingsLine /> Name and objective</h3>}>

                  <div className="acc_campaign_set">
                    <div className="row pt-2">
                      <div className="col-md-6 pr-2">
                        <Item
                          required
                          label="Campaign title"
                          name="name"
                          initialValue={campaignData?.title || undefined}
                        >
                          <Input className="common_input"
                            size="large"
                            placeholder="Enter campaign name"
                            onChange={ (event) => syncCampaignData({ value: event?.target?.value, key: 'title' })} />
                        </Item>
                      </div>
                      <div className="col-md-6 pl-2">
                        <Item
                          required
                          label="Campaign objective"
                          name="objective"
                          initialValue={campaignData?.objective || undefined}
                        >
                          <Select
                            style={{ width: '100%' }}
                            className="common_select"
                            onChange={(value) => syncCampaignData({ value, key: 'objective' })}
                            size="large"
                            placeholder="Select Objective"
                          >
                            {
                              campaignobjective.map((objective, index) =>(
                                <Option key={`cobj_${index}`}
                                  value={objective.key}>{objective.name}</Option>
                              ))
                            }
                          </Select>
                        </Item>
                      </div>
                      <div className="col-md-6 pr-2 pt-4">
                        <Item
                          required
                          label="Platform"
                          name="platform"
                          initialValue={campaignData?.platform || undefined}
                        >
                          <Select
                            style={{ width: '100%' }}
                            className="common_select"
                            onChange={(value) => syncCampaignData({ value, key: 'platform' })}
                            size="large"
                            placeholder="Select Platform"
                          >
                            {
                              platform.map((objective, index) =>(
                                <Option key={`cobj_${index}`}
                                  value={objective.key}>{objective.name}</Option>
                              ))
                            }
                          </Select>
                        </Item>
                      </div>
                      <div className="col-md-6 pl-2 pt-4">
                        <Item
                          required
                          label="Budget"
                          name="budget"
                          initialValue={campaignData?.budget || undefined}
                        >
                          <Input className="common_input"
                            size="large"
                            placeholder="Budget"
                            onChange={ (event) => syncCampaignData({ value: event?.target?.value, key: 'budget' })} />
                        </Item>
                      </div>
                      <div className="col-md-6 pr-2 pt-4">
                        <Item
                          required
                          label="Brand ID"
                          name="brandid"
                          initialValue={campaignData?.brand || undefined}
                        >
                          <Input className="common_input"
                            size="large"
                            placeholder="Brand Id"
                            onChange={ (event) => syncCampaignData({ value: event?.target?.value, key: 'brand' })}/>
                        </Item>
                      </div>
                      <div className="col-md-6 pl-2 pt-4">
                        <Item
                          required
                          label="Company ID title"
                          name="companyid"
                          initialValue={campaignData?.company || undefined}
                        >
                          <Input className="common_input"
                            size="large"
                            placeholder="Company Id"
                            onChange={ (event) => syncCampaignData({ value: event?.target?.value, key: 'company' })} />
                        </Item>
                      </div>
                      <div className="col-md-6 pr-2 pt-4">
                        <Item
                          required
                          label="Estimated influencers count"
                          name="infCount"
                          initialValue={campaignData?.company || undefined}
                        >
                          <Input className="common_input"
                            size="large"
                            placeholder="Default 1000"
                            onChange={ (event) => syncCampaignData({ value: event?.target?.value, key: 'influencerscount' })} />
                        </Item>
                      </div>
                    </div>
                  </div>
                </Panel>
              </Collapse>
              <Collapse
                className="acc_campaign mb-2 common_collapse"
                showArrow={false}
                defaultActiveKey={['base-1']}
              >
                <Panel showArrow={false}
                  disabled
                  isActive={false}
                  header={<h3><GiHumanTarget />Target Influencers</h3>}>
                  <div className="acc_campaign_set">
                    <div className="row pt-2">
                      <div className="col-md-6 pr-2">
                        <Item
                          required
                          label="Influencer Type"
                          name="influencerType"
                          initialValue={campaignData?.influencersType || undefined}
                        >
                          <Select
                            style={{ width: '100%' }}
                            className="common_select"
                            mode="multiple"
                            disabled
                            onChange={(value) => syncCampaignData({ value, key: 'influencersType' })}
                            size="large"
                            placeholder="Influencer Type"
                          >
                            {
                              influencersType.map((objective, index) =>(
                                <Option key={`cobj_${index}`}
                                  value={objective.key}>{objective.name}</Option>
                              ))
                            }
                          </Select>
                        </Item>
                      </div>
                      <div className="col-md-6 pl-2">
                        <Item
                          required
                          label="Gender"
                          name="gender"
                          initialValue={campaignData?.gender || undefined}
                        >
                          <Select
                            style={{ width: '100%' }}
                            mode="multiple"
                            disabled
                            className="common_select"
                            onChange={(value) => syncCampaignData({ value, key: 'gender' })}
                            size="large"
                            placeholder="Gender"
                          >
                            {
                              gender.map((objective, index) =>(
                                <Option key={`cobj_${index}`}
                                  value={objective.key}>{objective.name}</Option>
                              ))
                            }
                          </Select>
                        </Item>
                      </div>
                      <div className="col-md-6 pr-2 pt-4">
                        <Item
                          required
                          label="Age Group"
                          name="ageGroup"
                          initialValue={campaignData?.ageGroup || undefined}
                        >
                          <Select
                            style={{ width: '100%' }}
                            className="common_select"
                            mode="multiple"
                            disabled
                            onChange={(value) => syncCampaignData({ value, key: 'ageGroup' })}
                            size="large"
                            placeholder="Age Group"
                          >
                            {
                              ageGroup.map((objective, index) =>(
                                <Option key={`cobj_${index}`}
                                  value={objective.key}>{objective.name}</Option>
                              ))
                            }
                          </Select>
                        </Item>
                      </div>
                      <div className="col-md-6 pl-2 pt-4">
                        <Item
                          required
                          label="Languages"
                          name="languages"
                          initialValue={campaignData?.languages || undefined}
                        >
                          <Input disabled
                            className="common_input"
                            size="large"
                            placeholder="Languages"
                            onChange={ (event) => syncCampaignData({ value: event?.target?.value, key: 'languages' })} />
                        </Item>
                      </div>
                      <div className="col-md-6 pr-2 pt-4">
                        <Item
                          required
                          label="Interset"
                          name="interset"
                          initialValue={campaignData?.interest || undefined}
                        >
                          <Input disabled
                            className="common_input"
                            size="large"
                            placeholder="Interset"
                            onChange={ (event) => syncCampaignData({ value: event?.target?.value, key: 'interest' })} />
                        </Item>
                      </div>
                      <div className="col-md-6 pl-2 pt-4">
                        <Item
                          required
                          label="Location"
                          name="location"
                          initialValue={campaignData?.location || undefined}
                        >
                          <Input disabled
                            className="common_input"
                            size="large"
                            placeholder="Location"
                            onChange={ (event) => syncCampaignData({ value: event?.target?.value, key: 'location' })} />
                        </Item>
                      </div>
                      <div className="col-md-6 pr-2 pt-4">
                        <Item
                          required
                          label="Influencers List"
                          name="influencersList"
                          initialValue={campaignData?.influencerList || undefined}
                        >
                          <Select
                            style={{ width: '100%' }}
                            className="common_select"
                            disabled
                            onChange={(value) => syncCampaignData({ value, key: 'influencerList' })}
                            size="large"
                            placeholder="Influencers List"
                          >
                            {
                              platform.map((objective, index) =>(
                                <Option key={`cobj_${index}`}
                                  value={objective.key}>{objective.name}</Option>
                              ))
                            }
                          </Select>
                        </Item>
                      </div>
                    </div>
                  </div>
                </Panel>
              </Collapse>
              <Collapse
                className="acc_campaign mb-2 common_collapse"
                showArrow={false}
                defaultActiveKey={['base-1']}
              >
                <Panel showArrow={false}
                  key="base-1"
                  header={<h3><MdSchedule /> Schedule</h3>}>
                  <div className="acc_campaign_set">
                    <div className="row pt-2">
                      <div className="col-md-12 pr-2 d-flex">
                        <Item
                          initialValue={[(campaignData?.startdate ? moment(campaignData?.startdate) : undefined), (campaignData?.enddate ? moment(campaignData?.enddate) : undefined)]}
                          label="Select start & end Date with time (required)"
                          name="campDateTimeRange"
                        >
                          <RangePicker
                            className="common_input"
                            style={{ width: '100%' }}
                            onChange={(value) => syncCampaignData({ value, key: 'date' })}
                            size="large"
                            format="Do MMM yyyy HH:mm a"
                            showTime={{ defaultValue: [moment('00:00', 'HH:mm'), moment('11:59', 'HH:mm')] }}
                            rules={ [{ type: 'object', required: true, message: 'Please select start & end date with time' }] }
                          />
                        </Item>
                      </div>
                    </div>
                  </div>
                </Panel>
              </Collapse>
              <Collapse
                className="acc_campaign mb-2 common_collapse"
                showArrow={false}
                defaultActiveKey={['base-1']}
              >
                <Panel showArrow={false}
                  disabled
                  header={<h3><AiOutlineFire /> Creatives</h3>}>
                  <p>Creatives data</p>
                </Panel>
              </Collapse>
              <Collapse
                className="acc_campaign mb-2 common_collapse"
                showArrow={false}
                defaultActiveKey={['base-1']}
              >
                <Panel showArrow={false}
                  disabled
                  header={<h3><AiOutlinePaperClip /> Brief</h3>}>
                  <div className="acc_campaign_set">
                    <div className="row pt-2">
                      <div className="col-md-6 pr-2">
                        <Item
                          required
                          label="Description"
                          name="description"
                          initialValue={campaignData?.description || undefined}
                        >
                          <Input className="common_input"
                            size="large"
                            placeholder="Description"
                            onChange={ (event) => syncCampaignData({ value: event?.target?.value, key: 'description' })} />
                        </Item>
                      </div>
                      <div className="col-md-6 pl-2">
                        <Item
                          required
                          label="Hashtags"
                          name="hashtags"
                          initialValue={campaignData?.hashtags || undefined}
                        >
                          <Input className="common_input"
                            size="large"
                            placeholder="Hashtags"
                            onChange={ (event) => syncCampaignData({ value: event?.target?.value, key: 'hashtags' })} />
                        </Item>
                      </div>
                      <div className="col-md-6 pr-2 pt-4">
                        <Item
                          required
                          label="Keywords"
                          name="keywords"
                          initialValue={campaignData?.keywords || undefined}
                        >
                          <Input className="common_input"
                            size="large"
                            placeholder="Keywords"
                            onChange={ (event) => syncCampaignData({ value: event?.target?.value, key: 'keywords' })}/>
                        </Item>
                      </div>
                      <div className="col-md-6 pl-2 pt-4">
                        <Item
                          required
                          label="Mentions"
                          name="mentions"
                          initialValue={campaignData?.mentions || undefined}
                        >
                          <Input className="common_input"
                            size="large"
                            placeholder="Mentions"
                            onChange={ (event) => syncCampaignData({ value: event?.target?.value, key: 'mentions' })} />
                        </Item>
                      </div>
                      <div className="col-md-6 pr-2 pt-4">
                        <Item
                          required
                          label="Reference Links"
                          name="referenceLinks"
                          initialValue={campaignData?.referenceLinks || undefined}
                        >
                          <Input className="common_input"
                            size="large"
                            placeholder="Reference Links"
                            onChange={ (event) => syncCampaignData({ value: event?.target?.value, key: 'referenceLinks' })} />
                        </Item>
                      </div>
                      <div className="col-md-6 pl-2 pt-4">
                        <Item
                          required
                          label="Campaign Guidelines"
                          name="campaignGuidelines"
                          initialValue={campaignData?.campaignGuidelines || undefined}
                        >
                          <Input className="common_input"
                            size="large"
                            placeholder="Campaign Guidelines"
                            onChange={ (event) => syncCampaignData({ value: event?.target?.value, key: 'campaignGuidelines' })} />
                        </Item>
                      </div>
                    </div>

                  </div>
                </Panel>
              </Collapse>
              <Button className='common_button'
                style={{ width: '100%' }}
                onClick={submitCampaign}>Submit</Button>

            </div>
          </Form>
        </div>
      </div>
    </BaseLayoutComponent>
  );
};

export default AdminCreateCampaignPage;
